import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

export const calculatePriceForPoint = async (price, config) => {
  try {
    const { data } = await redemptionsApiClient.get(
      `Product/ConvertedPrice?price=${price}`,
      {
        headers: {
          price: price,
          ...config,
        },
      }
    );
    return data.points;
  } catch (error) {
    console.log(error);
  }
};
